import React from "react";
import { Link } from "react-router-dom";
import "../../css/MainPage/HomePage.css";
import home1 from "../../assets/header-images/home1.jpg";
import quotepic from "../../assets/Logo/LogoCopy.png";
import quotesicon from "../../assets/inner-content-images-and-files/QuotePic.png";
// University logo imports
import uclaLogo from "../../assets/UniversityLogos/UCLA.png";
import ucbLogo from "../../assets/UniversityLogos/UCB.png";
import uciLogo from "../../assets/UniversityLogos/UCI.png";
import ucsdLogo from "../../assets/UniversityLogos/UCSD.png";
import ucdLogo from "../../assets/UniversityLogos/UCD.png";
// Mission section image
import missionImage from "../../assets/header-images/achievements.jpg";
// University logo imports would go here in a real implementation
// For this example, we'll create placeholder elements with appropriate styling

function HomePage() {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-tag">Your College Success Partner</span>
          <h1>Navigate Your College Journey with Confidence</h1>
          <p>
            Your comprehensive platform for college preparation, scholarships,
            and student success strategies tailored to your educational goals
          </p>
          <div className="hero-cta">
            <Link to="/college-prep" className="cta-button primary">
              Get Started
            </Link>
            <Link to="/about-us" className="cta-button secondary">
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">200+</div>
              <div className="stat-label">Resources Available</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">100+</div>
              <div className="stat-label">Students Helped</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">$2M+</div>
              <div className="stat-label">Scholarships Found</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-wrapper">
            <div className="mission-content">
              <div className="section-tag">Our Mission</div>
              <h2>Your Path to Academic Excellence</h2>
              <p>
                At CollegeNav, we empower students through every step of their
                educational journey with expert guidance, comprehensive
                resources, and personalized support systems.
              </p>
              <div className="mission-features">
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">
                    Personalized guidance for your unique journey
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">
                    Expert-verified resources and information
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">
                    Community support from peers and mentors
                  </div>
                </div>
              </div>
              <Link to="/about-us" className="text-link">
                Learn about our approach <span className="arrow">→</span>
              </Link>
            </div>
            <div className="mission-image">
              <img
                src={missionImage}
                alt="Student achievements and academic excellence"
                className="mission-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Resources Section */}
      <section className="featured-section">
        <div className="container">
          <div className="section-tag">Featured Resources</div>
          <div className="section-header">
            <h2>Start Your College Journey</h2>
            <p>
              Our most popular resources to help you get started on your path to
              higher education
            </p>
          </div>

          <div className="featured-cards">
            <div className="featured-card">
              <div className="featured-icon scholarship-icon">🎓</div>
              <h3>Scholarship Guide</h3>
              <p>
                Comprehensive resources for finding and securing scholarships
              </p>
              <Link to="/afford-college/scholarship" className="card-link">
                Explore Guide <span className="arrow">→</span>
              </Link>
            </div>

            <div className="featured-card">
              <div className="featured-icon application-icon">📝</div>
              <h3>Application Process</h3>
              <p>
                Step-by-step guidance through the college application process
              </p>
              <Link
                to="/college-prep/application-process"
                className="card-link"
              >
                Get Started <span className="arrow">→</span>
              </Link>
            </div>

            <div className="featured-card">
              <div className="featured-icon calculator-icon">💰</div>
              <h3>Financial Tools</h3>
              <p>Calculators and trackers to plan your college finances</p>
              <Link to="/tools/financial-tracker" className="card-link">
                Use Tools <span className="arrow">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Resources Section */}
      <section className="resources-section">
        <div className="container">
          <div className="section-tag">Complete Resources</div>
          <div className="section-header">
            <h2>Everything You Need</h2>
            <p>
              A comprehensive collection of resources to guide you from high
              school preparation to college graduation and beyond
            </p>
          </div>

          <div className="resources-grid">
            <div className="resource-card">
              <div className="card-header">
                <span className="step-label">Step 1</span>
                <h3>
                  <span className="card-icon">🎓</span> College Prep
                </h3>
              </div>
              <div className="resource-content">
                <div className="resource-item">
                  <Link to="/college-prep/highschool-roadmap">
                    <span className="resource-icon"></span>
                    <span className="resource-name">High School Roadmap</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college-prep/different-paths">
                    <span className="resource-icon"></span>
                    <span className="resource-name">
                      Exploring Different Paths
                    </span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college-prep/majors">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Choosing a Major</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college-prep/college-search-guide">
                    <span className="resource-icon"></span>
                    <span className="resource-name">College Search</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college-prep/application-process">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Application Process</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college-prep/college-essay">
                    <span className="resource-icon"></span>
                    <span className="resource-name">College Essays</span>
                  </Link>
                </div>
              </div>
              <div className="card-footer">
                <Link to="/college-prep" className="card-button">
                  View All Resources
                </Link>
              </div>
            </div>

            <div className="resource-card">
              <div className="card-header">
                <span className="step-label">Step 2</span>
                <h3>
                  <span className="card-icon">💰</span> Afford College
                </h3>
              </div>
              <div className="resource-content">
                <div className="resource-item">
                  <Link to="/afford-college/financial-aid">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Financial Aid</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/afford-college/scholarship">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Scholarships</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/afford-college/scholarship/understanding-scholarship">
                    <span className="resource-icon"></span>
                    <span className="resource-name">
                      Understanding Scholarships
                    </span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/afford-college/scholarship/scholarship-search-guide">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Scholarship Search</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/afford-college/scholarship/application-tips">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Application Tips</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/afford-college/student-work-opportunities">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Work Opportunities</span>
                  </Link>
                </div>
              </div>
              <div className="card-footer">
                <Link to="/afford-college" className="card-button">
                  View All Resources
                </Link>
              </div>
            </div>

            <div className="resource-card">
              <div className="card-header">
                <span className="step-label">Step 3</span>
                <h3>
                  <span className="card-icon">🏫</span> College Life
                </h3>
              </div>
              <div className="resource-content">
                <div className="resource-item">
                  <Link to="/college/before-college">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Preparing for College</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college/college-tips">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Essential Tips</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college/school-benefits">
                    <span className="resource-icon"></span>
                    <span className="resource-name">School Benefits</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/college/stem-internships">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Internships</span>
                  </Link>
                </div>

                <div className="resource-item">
                  <Link to="/college/resume">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Resume Building</span>
                  </Link>
                </div>
              </div>
              <div className="card-footer">
                <Link to="/college" className="card-button">
                  View All Resources
                </Link>
              </div>
            </div>

            <div className="resource-card">
              <div className="card-header">
                <span className="step-label">Step 4</span>
                <h3>
                  <span className="card-icon">🚀</span> Programs
                </h3>
              </div>
              <div className="resource-content">
                <div className="resource-item">
                  <Link to="/programs/research-opportunities">
                    <span className="resource-icon"></span>
                    <span className="resource-name">
                      Research Opportunities
                    </span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/programs/study-abroad">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Study Abroad</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/programs/mentorship-programs">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Mentorship</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/programs/tech-conferences">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Tech Conferences</span>
                  </Link>
                </div>
              </div>
              <div className="card-footer">
                <Link to="/programs" className="card-button">
                  View All Resources
                </Link>
              </div>
            </div>

            <div className="resource-card">
              <div className="card-header">
                <span className="step-label">Step 5</span>
                <h3>
                  <span className="card-icon">⚙️</span> Tools
                </h3>
              </div>
              <div className="resource-content">
                <div className="resource-item">
                  <Link to="/tools/ai">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Aza (AI Chatbot)</span>
                  </Link>
                </div>
                {/* Hidden for now */}
                <div className="resource-item">
                  <Link to="/tools/early-career-search">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Career Search</span>
                  </Link>
                </div>
                {/* <div className="resource-item">
                  <Link to="/tools/financial-tracker">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Financial Tracker</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/tools/gpa-calculator">
                    <span className="resource-icon"></span>
                    <span className="resource-name">GPA Calculator</span>
                  </Link>
                </div> */}
                <div className="resource-item">
                  <Link to="/tools/college-search">
                    <span className="resource-icon"></span>
                    <span className="resource-name">College Search</span>
                  </Link>
                </div>
                <div className="resource-item">
                  <Link to="/tools/scholarship-search">
                    <span className="resource-icon"></span>
                    <span className="resource-name">Scholarship Search</span>
                  </Link>
                </div>
              </div>
              <div className="card-footer">
                <Link to="/tools" className="card-button">
                  View All Tools
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section">
        <div className="container">
          <div className="testimonial-wrapper">
            <div className="testimonial-background"></div>
            <div className="testimonial-content">
              <div className="section-tag">Our Commitment</div>
              <img className="quote-icon" src={quotesicon} alt="Quote" />
              <p className="testimonial-text">
                "Every student deserves the chance to reach their full
                potential. At CollegeNav, we're here to guide you on your
                journey to success with the tools, resources, and support you
                need to confidently navigate the path to higher education."
              </p>
              <div className="testimonial-author">
                <img className="author-img" src={quotepic} alt="CollegeNav" />
                <div className="author-info">
                  <h3 className="author-name">CollegeNav</h3>
                  <p className="author-position">Student Success Team</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-background"></div>
          <div className="cta-content">
            <div className="section-tag light">Join Our Community</div>
            <h2>Get Involved</h2>
            <p>
              Your support is invaluable to us. Whether you share your own
              experiences or explore partnership opportunities, your involvement
              helps us continue to provide crucial resources and guidance to
              students as they embark on their college journey.
            </p>
            <div className="cta-buttons">
              <Link to="/contact-us" className="cta-button primary">
                Partner With Us
              </Link>
              <Link to="/subscribe" className="cta-button secondary light">
                Subscribe to Updates
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Signals Section */}
      <section className="trust-section">
        <div className="container">
          <div className="trust-header">
            <h3>Trusted by students from top universities nationwide</h3>
          </div>
          <div className="university-logos">
            <div className="university-logo">
              <img src={uclaLogo} alt="UCLA" className="school-logo" />
              <span className="school-name">UCLA</span>
            </div>
            <div className="university-logo">
              <img src={ucbLogo} alt="UC Berkeley" className="school-logo" />
              <span className="school-name">UC Berkeley</span>
            </div>
            <div className="university-logo">
              <img src={uciLogo} alt="UC Irvine" className="school-logo" />
              <span className="school-name">UC Irvine</span>
            </div>
            <div className="university-logo">
              <img src={ucsdLogo} alt="UC San Diego" className="school-logo" />
              <span className="school-name">UC San Diego</span>
            </div>
            <div className="university-logo">
              <img src={ucdLogo} alt="UC Davis" className="school-logo" />
              <span className="school-name">UC Davis</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
